import React from 'react'
import { Row, Col, Table, MenuItem, DropdownButton } from "react-bootstrap"
import PropTypes from "prop-types"
import { green, videoblue, warning } from '../../utils/constants'

const UserSearchResult = (props) => {
  const {
    users,
    handleDenyClick,
    handleRevokeClick,
    handleApproveClick
  } = props;

  return (
    <Row>
      <Col sm={12} md={10}>
        {users &&
          users.length == 0 &&
          (
            <div>
              <span style={{ color: warning, fontSize: '15px' }} >
                <i className="fa fa-info-circle" />&nbsp;&nbsp;No records found matching specified criteria.
                </span>
            </div>
          )}
        {users &&
          users.length > 0 &&
          (
            [
              <span key={1} style={{ color: videoblue, fontWeight: 'bold', fontSize: '15px' }}>
                <i className="fa fa-users" style={{ color: videoblue, fontWeight: 'bold' }} />&nbsp;&nbsp;{users.length} users found
                  </span>,
              <Table key={2} striped>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Role</th>
                    <th>Email</th>
                    <th>Member Id</th>
                    <th>SSO ID</th> 
                    <th>Status</th>
                    <th style={{ width: "60px" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {users &&
                    users.map((item, key) => (
                      <tr key={key}>
                        <td>
                          { /* <a href="#">{item.firstName + ' ' + item.lastName}</a> */
                          }
                          <a style={{ color: '#656565' }}>{item.firstName + ' ' + item.lastName}</a>
                        </td>
                        <td>{item.role}</td>
                        <td>{item.emailAddress}</td>
                        <td>{item.usbcMembershipId}</td>
                        <td>{item.ssoUserId}</td> 
                        <td>{item.status}</td>
                        <td>
                          {
                            item.status !== 'Pending User Registration' &&
                            item.status !== 'Deactivated' &&
                            item.status !== 'Denied' &&
                            <DropdownButton style={{ maxWidth: '30px' }} pullRight noCaret title={<i className="fa fa-angle-right" />} id={"approvalActionBtn" + key}>
                              {
                                item.status == 'Active' &&
                                <MenuItem eventKey="1">
                                  <span style={{ color: 'red' }} onClick={handleRevokeClick} data-key={item.id}>
                                    <i className="fa fa-user-times  text-muted mr-sm" style={{ color: 'red' }} />
                                    Deactivate
                                </span>
                                </MenuItem>
                              }
                              {
                                item.status == 'Pending Approval' &&
                                <MenuItem eventKey="2">
                                  <span style={{ color: green }} onClick={handleApproveClick} data-key={item.id}>
                                    <i className="fa fa-thumbs-up text-muted mr-sm" style={{ color: green }} />
                                    Approve
                                  </span>
                                </MenuItem>
                              }
                              {
                                (item.status == 'Pending Approval' ||
                                  item.status == 'Pending User Acceptance') &&
                                <MenuItem eventKey="3">
                                  <span style={{ border: 'none', padding: '0' }} onClick={handleDenyClick} data-key={item.id}>
                                    <i className="fa fa-thumbs-down text-muted mr-sm" /> Deny
                                  </span>
                                </MenuItem>
                              }
                            </DropdownButton>
                          }
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            ])}
      </Col>
    </Row>
  );
}

UserSearchResult.propTypes = {
  users: PropTypes.array,
  handleDenyClick: PropTypes.func,
  handleApproveClick: PropTypes.func.isRequired,
  handleRevokeClick: PropTypes.func.isRequired
};

export default UserSearchResult


// WEBPACK FOOTER //
// ./src/containers/user/usersearchresult.js